/* eslint-disable import/prefer-default-export */

import { ShadowType } from '@src/endpoints/services/graphQueryMgr.service'

export const ShadowAccessTabs = [
  ShadowType.SHADOW_UNKNOWN_ACCOUNT,
  ShadowType.SHADOW_KNOWN_ACCOUNT,
  ShadowType.SHADOW_KNOWN_NETWORK
]

export const TabLabels = new Map<ShadowType, string>([
  [ShadowType.SHADOW_UNKNOWN_ACCOUNT, 'Unknown Sources'],
  [ShadowType.SHADOW_KNOWN_ACCOUNT, 'Known Sources'],
  [ShadowType.SHADOW_KNOWN_NETWORK, 'Shadow Networks']
])
